module.exports = __webpack_public_path__ + "7accc5895000107dbb99f82e5319ca5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room7/sleepingpollenweb.jpg
// module id = 902
// module chunks = 0